import { extendTheme } from "@chakra-ui/react"
import { createBreakpoints } from "@chakra-ui/theme-tools"

const breakpoints = createBreakpoints({
  sm: "400px",
  md: "900px",
  lg: "1095px",
  // xl: "80em",
  // "2xl": "96em",
})

const theme = extendTheme({
  breakpoints,
  colors: {
    primary: {
      100: "#fff",
      200: "#F1EBFE", //fade white
      300: "#F1F0F0" //dashboard fade white
    },
    secondary: {
     purple: "#8000FF", // purple
     active_nav_color: "#8000ff",
     active_nav_bg: "#8000ff2b",
     nav_gray: "#807d7d", // nav in normal state
     black: "#000000",
     white: "#ffffff",
     gray: "#C4C4C4",
     fade_green: "#CBFFD3",
     green: "#14F137",
     red: "#FF0000",
     fade_red: "#ff000042"
    }
  },
})


export default theme;